// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__35qVR","row":"styles_row__1noaj"};